import * as classNames from 'classnames';
import * as React from 'react';
import * as style from './Button.styl';

import { IconName } from '@ReactConstants/iconNames';
import { Spinner } from '@ReactComponents/Spinner/Spinner';

interface IButtonProps {
  /**
   * Solid blue button
   */
  primary?: boolean;
  /**
   * Outlined blue button
   */
  primaryGhost?: boolean;
  /**
   * Solid green button
   */
  alt?: boolean;
  /**
   * Solid alt blue button
   */
  positive?: boolean;
  /**
   * Outlined green button
   */
  positiveGhost?: boolean;
  /**
   * Solid red button
   */
  negative?: boolean;
  /**
   * Outlined red button
   */
  negativeGhost?: boolean;
  /**
   * Outlined white button. Primarily used on darker backgrounds
   */
  whiteGhost?: boolean;
  /**
   * Disables the button
   */
  disabled?: boolean;
  /**
   * Displays a spinner inside the button
   */
  spinning?: boolean;
  /**
   * Name of an icon that would go in the button
   */
  icon?: IconName;
  /**
   * Only shows the icon when hovering over the button
   */
  showIconOnHover?: boolean;
  /**
   * Renders the button extra small
   */
  xsmall?: boolean;
  /**
   * Renders the button small
   */
  small?: boolean;
  /**
   * Renders the button large
   */
  large?: boolean;
  /**
   * Makes button take full width of the parent
   */
  full?: boolean;
  /**
   * Content inside of the button (text)
   */
  children?: React.ReactNode;
  /**
   * Action taken when button is clicked
   */
  onClick?: (event?: React.MouseEvent) => void;
  type?: 'submit' | 'reset' | 'button';
  nav?: boolean;
  primaryNav?: boolean;
  secondaryNav?: boolean;
  className?: string;
}

export class Button extends React.Component<IButtonProps> {
  constructor(props: IButtonProps) {
    super(props);
  }
  render() {
    const {
      alt,
      primary,
      primaryGhost,
      positive,
      positiveGhost,
      negative,
      negativeGhost,
      whiteGhost,
      disabled,
      spinning,
      children,
      onClick,
      icon,
      showIconOnHover,
      xsmall,
      small,
      large,
      full,
      nav,
      primaryNav,
      secondaryNav,
      type,
      className,
      ...other
    } = this.props;

    const buttonClassNames = classNames(style.global, className, {
      alt: alt,
      primary: primary,
      primaryGhost: primaryGhost,
      positive: positive,
      positiveGhost: positiveGhost,
      negative: negative,
      negativeGhost: negativeGhost,
      whiteGhost: whiteGhost,
      disabled: disabled,
      spinning: spinning,
      showIconOnHover: showIconOnHover,
      xsmall: xsmall,
      small: small,
      large: large,
      full: full,
      nav: nav,
      primaryNav: primaryNav,
      secondaryNav: secondaryNav
    });

    return (
      <button disabled={disabled} className={buttonClassNames} onClick={onClick} type={type} {...other}>
        {Boolean(icon) && <span className={classNames('iconName', 'icon', 'icon-' + icon)} />}
        {showIconOnHover && <span className={classNames('showIconOnHover', 'icon', 'icon-' + showIconOnHover)} />}

        {spinning ? <Spinner /> : null}
        {!spinning ? <span>{children}</span> : null}
      </button>
    );
  }
}
